import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { filter, map, take } from 'rxjs/operators';
import { SgsstAuthUserService } from '../modules/shared/services/auth.service';
import { StorageService } from '../modules/shared/services/storage.service';
import { hasValidTenantContext } from '../utils/session-tenant-context.util';

/**
 * Bloquea deep-links de módulos feature cuando no hay compañía/rol válidos.
 * Espera a que termine checkUserAuth para no autorizar con storage stale.
 * Redirige a `/` para mostrar el overlay SST del topbar.
 */
export const tenantContextGuard: CanActivateFn = () => {
  const storage = inject(StorageService);
  const msal = inject(MsalService);
  const router = inject(Router);
  const auth = inject(SgsstAuthUserService);

  const hasAccount = msal.instance.getAllAccounts().length > 0;
  if (!hasAccount) {
    return true;
  }

  return auth.tenantResolutionState$.pipe(
    filter(state => state === 'resolved'),
    take(1),
    map(() => {
      if (hasValidTenantContext(storage)) {
        return true;
      }
      return router.createUrlTree(['/']);
    })
  );
};
